"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import React from "react";
import classnames from "classnames";
import Avatar, { AvatarType } from "../../../pieces/Avatar/Avatar";
import { Tick } from "../../../icons";
const BASE_CLASS_NAME = "user-card";
const UserCard = ({
  user,
  selected = false,
  onClick,
  children,
  className,
  avatarType = AvatarType.User
}) => {
  const avatarNameProps = avatarType === AvatarType.User ? { firstName: user.firstName, lastName: user.lastName } : {};
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classnames(BASE_CLASS_NAME, className, {
        [`${BASE_CLASS_NAME}--selected`]: selected
      }),
      onClick
    },
    /* @__PURE__ */ React.createElement(Avatar, __spreadValues({ type: avatarType }, avatarNameProps)),
    /* @__PURE__ */ React.createElement("div", { className: `${BASE_CLASS_NAME}__details` }, /* @__PURE__ */ React.createElement("span", { className: `${BASE_CLASS_NAME}__name` }, `${user.firstName} ${user.lastName || ""}`), user.email && /* @__PURE__ */ React.createElement("span", { className: `${BASE_CLASS_NAME}__email` }, user.email)),
    /* @__PURE__ */ React.createElement("div", { className: `${BASE_CLASS_NAME}__spacer` }),
    /* @__PURE__ */ React.createElement("div", { className: `${BASE_CLASS_NAME}__children`, onClick: (event) => event.stopPropagation() }, children),
    selected && /* @__PURE__ */ React.createElement(Tick, { className: `${BASE_CLASS_NAME}__tick` })
  );
};
export default UserCard;
